<template>
  <div>
    <v-card class="pa-0">
      <v-card-text class="pa-4 py-0 pr-1">
        <v-row>
          <v-col cols="12">
            <!--  편집모드일 경우 -->
            <div v-if="signature.mode == 'edit'">
              <div class="d-flex">
                <span class="mt-3 pt-2 pl-1" style="font-size: 0.66rem; color:black">서명 ( {{ signature.mode }} mode)</span>
                <div class="d-flex ml-auto mr-0 mt-3">
                  <v-btn icon class="ml-0 pa-0 mr-0" height="auto" width="80px" @click="saveSign">
                    <v-icon small color="primary">mdi-check</v-icon>
                    <span style="font-size: 0.66rem; color:black">편집 완료</span>
                  </v-btn>
                  <v-btn icon class="ml-0 pa-0 mr-0" height="auto" width="30px" @click="clearSign">
                    <v-icon small color="primary">mdi-close-circle-outline</v-icon>
                  </v-btn>
                </div>
              </div>
              <VueSignaturePad id="signature" width="100%" height="156px" ref="signaturePad" />
            </div>

            <!--  디스플레이모드일 경우 -->
            <div v-else>
              <div class="d-flex">
                <span class="mt-3 pt-2 pl-1" style="font-size: 0.66rem; color:black">서명 ( {{ signature.mode }} mode)</span>
                <div class="d-flex ml-auto mr-0 mt-3">
                  <v-btn icon class="ma-0 pa-0" height="auto" width="60px" @click="editSign">
                    <v-icon small color="primary">mdi-draw</v-icon>
                    <span style="font-size: 0.66rem; color:black">편집</span>
                  </v-btn>
                </div>
              </div>
              <img v-if="signature.data" :src="signature.data" id="signature_display" width="100%" height="150px" style="padding:0; margin:0;" />
              <div v-else style="width:100%; height:156px; border: 1px gray solid; display:flex; justify-content: center; align-items: center;">
                <span>서명 없음</span>
              </div>
            </div>
          </v-col>
        </v-row>
      </v-card-text>

      <v-card-actions class="mr-2 pb-4">
        <v-spacer></v-spacer>
        <v-btn small elevation="0" outlined height="28" width="70" class="rounded mr-1" color="btn_text" @click="close()">
          <div class="float-center mx-1 font-weight-bold" style="color: #0E1113;">닫기</div>
        </v-btn>
        <v-btn small elevation="0" height="28" width="70" class="rounded mr-4" dark color="btn_sub" @click="save()">
          <div class="float-center font-weight-bold">저장</div>
        </v-btn>
      </v-card-actions>
    </v-card>
  </div>
</template>

<script>
import { savePrivateUser } from '@/api/system/userManage'
import { getUserCd } from '@/utils/token'
import baseview from '@/views/base/baseview.vue' //20220414 LYJ base page 추가
export default {
  mixins: [baseview],
  name: 'edit-sign',
  components: {},
  props: {
    // onclose: {
    //   type: Function
    // },
  },
  data() {
    return {
      refreshKey: 0,
      params: {},
      signature: {
        mode: 'display', //edit,display
        data: '',
        isEmpty: false
      }
    }
  },
  computed: {},
  mounted() {},
  activate() {},
  methods: {
    editSign() {
      this.signature.mode = 'edit'
    },
    clearSign() {
      console.log('clearSign')
      this.$refs.signaturePad.clearSignature()
      this.signature.data = null
    },
    async saveSign() {
      const { isEmpty, data } = await this.$refs.signaturePad.saveSignature()
      if (isEmpty == false) {
        this.signature.isEmpty = true
        this.signature.data = data
        this.signature.mode = 'display'
      } else {
        this.vSnackbar(this.$t('서명이 없습니다.'), 'warn', 1000)
      }
    },
    async save() {
      console.log('save', this.params)
      if(this.signature.mode === 'edit') {
        this.vSnackbar(this.$t('편집 완료 버튼을 누른 후 저장하세요.'), 'warn', 1000)
        return
      }
      if(this.signature.data.length === 0) {
        this.vSnackbar(this.$t('서명이 없습니다.'), 'warn', 1000)
        return
      }
      // await this.saveSign()
      let params = {
        clntId: this.getClntId(),
        userCd: getUserCd(),
        signature: this.signature.data,
        updateSign: true
      }

      console.log('savePrivateUser', params)
      await savePrivateUser(params, false)
        .then(res => {
          if (res.success) {
            this.refreshKey += 1
            console.log('savePrivateUser result', res.list)
          }
        })
        .catch(error => {})
        .finally(() => {
          this.$emit('signPopupClosed', params)
        })
    },
    close() {
      console.log('onclose')
      this.params = {}
      // this.$refs.signaturePad.clearSignature()
      this.signature.data = null
      this.$emit('signPopupClosed', this.params)
    }
  }
}
</script>

<style lang="scss" scoped>
/*.v-dialog.v-dialog--active.v-dialog--persistent
{
  background: white;
}*/

//정보변경 스타일 적용 start [[
.theme--light.v-card {
  background-color: #fff !important;
}

#signature {
  border: double 1px transparent;
  border-radius: 3px;
  background-image: linear-gradient(white, white), radial-gradient(circle at top left, #4bc5e8, #9f6274);
  background-origin: border-box;
  background-clip: content-box, border-box;
}

#signature_display {
  border: double 1px transparent;
  border-radius: 3px;
  background-image: linear-gradient(white, white), radial-gradient(circle at top left, #4bc5e8, #9f6274);
  background-origin: border-box;
  background-clip: content-box, border-box;
}

.container {
  width: '100%';
  padding: 8px 16px;
}

.buttons {
  display: flex;
  gap: 8px;
  justify-content: center;
  margin-top: 8px;
}
</style>
